(function () {
  'use strict';

  // CUSTOM events only. The Google & YouTube channel's GA4 integration already tracks
  // the standard ecommerce funnel (view_item, add_to_cart, begin_checkout, purchase,
  // search, ...) and page_view. We deliberately do NOT duplicate those here — this file
  // only covers interactions the channel cannot see.
  //
  // All events go through window.fbTrack (snippets/fb-ga4.liquid), which queues until
  // Shopify analytics consent is granted, then flushes. Falls back to gtag if needed.
  function track(name, params) {
    if (typeof window.fbTrack === 'function') {
      window.fbTrack(name, params || {});
    } else if (typeof window.gtag === 'function') {
      try { window.gtag('event', name, params || {}); } catch (e) {}
    }
  }

  function closest(el, selector) {
    return el && el.closest ? el.closest(selector) : null;
  }

  function labelOf(el) {
    return (el.getAttribute('aria-label') || el.textContent || '')
      .replace(/\s+/g, ' ').trim().slice(0, 100);
  }

  // ---------------------------------------------------------------------------
  // In-page anchor smooth scroll (bubble phase, fires after tracking).
  // Catches any <a> whose href is either "#hash" or the same page path + "#hash".
  // Needed because Shopify's URL picker stores the full page path when a page is
  // selected from the list, so Section-builder buttons may end up with
  // "/pages/florist-sabitia-sofia#events-inquiry" instead of "#events-inquiry".
  // ---------------------------------------------------------------------------
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href]');
    if (!link) return;
    var href = link.getAttribute('href') || '';
    var hashIdx = href.lastIndexOf('#');
    if (hashIdx === -1) return;
    var hash = href.slice(hashIdx);
    if (hash.length < 2) return;
    var pathPart = href.slice(0, hashIdx);
    // Accept pure anchors and same-path anchors.
    if (pathPart && pathPart !== location.pathname) return;
    var target;
    try { target = document.querySelector(hash); } catch (_) { return; }
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    try { history.pushState(null, '', hash); } catch (_) {}
  });

  // ---------------------------------------------------------------------------
  // Delegated clicks (capture phase so we run before navigation).
  // Priority: explicitly tagged CTAs -> tel/viber links -> bouquet-builder open
  // triggers -> generic buttons. Each branch returns so a click counts once.
  // ---------------------------------------------------------------------------
  document.addEventListener('click', function (e) {
    var t = e.target;

    // 1. Explicitly tagged CTA — stable id via data-fb-cta, independent of button
    //    text. Lets us tell apart specific buttons (e.g. the bouquet-builder Viber
    //    button vs a footer Viber link). Optional data-fb-lead also fires a lead.
    var tagged = closest(t, '[data-fb-cta]');
    if (tagged) {
      track('cta_click', {
        cta_id: tagged.getAttribute('data-fb-cta'),
        cta_label: labelOf(tagged) || 'unlabeled',
        link_url: tagged.getAttribute('href') || '',
        page_path: location.pathname
      });
      var lead = tagged.getAttribute('data-fb-lead');
      if (lead) track('generate_lead', { form_type: lead });
      return;
    }

    // 2. Phone / Viber links — contact intent. Skip the Събития sections (they emit
    //    their own events inside [data-tracking-id]).
    var tel = closest(t, 'a[href^="tel:"]');
    if (tel && !closest(t, '[data-tracking-id]')) {
      track('contact_click', { method: 'phone', link_url: tel.getAttribute('href') || '' });
      return;
    }
    var viber = closest(t, 'a[href^="viber:"]');
    if (viber && !closest(t, '[data-tracking-id]')) {
      track('contact_click', { method: 'viber', link_url: viber.getAttribute('href') || '' });
      return;
    }

    // 3. Bouquet-builder open triggers (scattered across pages, not individually
    //    tagged): elements with data-pz-open or a link to #personal-bouquet-form.
    var opener = closest(t, '[data-pz-open], a[href="#personal-bouquet-form"]');
    if (opener) {
      track('cta_click', {
        cta_id: 'bouquet_builder_open',
        cta_label: labelOf(opener) || 'unlabeled',
        page_path: location.pathname
      });
      return;
    }

    // 4. Generic site-wide CTA clicks — any theme .button or the mobile sticky
    //    actions. Exclude the Събития sections (own events_cta_click).
    var btn = closest(t, '.button, .pz-mobile-actions__atc, .pz-mobile-actions__call, .pz-mobile-actions__viber');
    if (btn && !closest(btn, '[data-tracking-id]') && !btn.hasAttribute('data-ev-cta')) {
      track('cta_click', {
        cta_label: labelOf(btn) || 'unlabeled',
        link_url: btn.getAttribute('href') || '',
        page_path: location.pathname
      });
    }
  }, true);

  // ---------------------------------------------------------------------------
  // Delegated form submits (capture phase). Search is handled by the channel, so
  // we only cover newsletter + contact, which it does not track.
  // ---------------------------------------------------------------------------
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches) return;

    // Newsletter signup ({% form 'customer' %} -> .email-signup__form)
    if (form.matches('.email-signup__form')) {
      track('sign_up', { method: 'newsletter' });
      return;
    }

    // Bouquet builder ({% form 'contact', class: 'pz-builder__form' %}). Its own
    // form_type so the completed 7-step lead is separable from a plain enquiry.
    if (form.matches('.pz-builder__form')) {
      track('generate_lead', { form_type: 'bouquet_builder' });
      return;
    }

    // Contact form ({% form 'contact' %}). The Събития inquiry form has its own
    // events_lead_submit and lives inside [data-tracking-id]; skip it here.
    if (form.matches('.contact-form__form') && !closest(form, '[data-tracking-id]')) {
      track('generate_lead', { form_type: 'contact' });
      return;
    }
  }, true);
})();
